import { render, staticRenderFns } from "./ResultSummaryLegend.vue?vue&type=template&id=11ef7459&scoped=true&"
import script from "./ResultSummaryLegend.vue?vue&type=script&lang=ts&"
export * from "./ResultSummaryLegend.vue?vue&type=script&lang=ts&"
import style0 from "./ResultSummaryLegend.vue?vue&type=style&index=0&id=11ef7459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ef7459",
  null
  
)

export default component.exports